/**
 * rmh
 * 签字-手写签
 * 2018.08.29
 */
import GlobalConfig from '../config/global';
import ApiPort from '../config/api-port';
import HttpAxios from './http-axios';
import {dealElement, handleResponse, handleError} from '../lib/common';

let junziqianApi = GlobalConfig.domain.junziqianApi;

export default {

  /**
   * 获取手签设置状态，参数为/getHandSecSign获取到的手签签名信息，
   * @param signNo
   * @param sign
   * @param imgData         手签图片base64
   * @param ts
   * @param updateTime      /hasHandSign接口获取，可空，手签的更新时间，
   * @returns {Promise<T>}
   */
  setHand (fd) {
    let url = junziqianApi + ApiPort.userSign.setHand;

    return HttpAxios.postForm(url, fd).then(handleResponse).catch(handleError);
  },
  setHandSign (fd) {
    let url = junziqianApi + ApiPort.userSign.setHandSign;
    return HttpAxios.postForm(url, fd).then(handleResponse).catch(handleError);
  },
  getHandSecSign () {
    let url = junziqianApi + ApiPort.userSign.getHandSecSign;
    return HttpAxios.post(url).then(handleResponse).catch(handleError);
  },
  /**
   * 同步手签状态用于pc,手机分屏操作，返回参数 data数据返回true，停止轮训，表示手签设置已完成，参数为/getHandSecSign获取到的手签签名信息，
   * @param signNo
   * @param sign
   * @param ts
   * @param updateTime    /hasHandSign接口获取，可空，手签的更新时间
   * @returns {Promise<T>}
   */
  syncHandStatus ({signNo, sign, ts, updateTime}) {
    let url = junziqianApi + ApiPort.userSign.syncHandStatus;
    let jsonData = {signNo: signNo, sign: sign, ts: ts, updateTime: updateTime || null};
    jsonData = dealElement(jsonData);

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  },

  /**
   * 获取手签签名，参数为原始网页上的签名信息
   * @param signNo
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  handSec ({signNo, sign, ts}) {
    let url = junziqianApi + ApiPort.userSign.handSec;
    let jsonData = {signNo: signNo, sign: sign, ts: ts};

    return HttpAxios.post(url, jsonData).then((res) => {
      let data = res.data;
      if (typeof data === 'string') {
        data = eval('(' + data + ')');
      }

      if (data.success === true || data.success === 'true') {
        data = data.data;

        return this.hasSign(jsonData).then((res) => {
          res = res.data;
          let url = `${GlobalConfig.domain.junziqianH5Op}/handSign?signNo=${signNo}&sign=${data.sign}&ts=${data.ts}&uid=${data.uid}`;
          url += res.updateTime ? `&updateTime=${res.updateTime}` : '';
          //signUrl: pc上编辑手写签字的回显图片用的
          let signUrl = res.handSignUrl ? `${GlobalConfig.domain.junziqianH5Op}/fileOper/show?targetId=${res.handSignUrl.targetId}&fileType=${res.handSignUrl.fileType}&sign=${res.handSignUrl.sign}&ts=${res.handSignUrl.ts}` : '';
          return {url: url, ts: data.ts, sign: data.sign, signNo: signNo, updateTime:res.updateTime || '', signUrl, uid: data.uid};
        });
      } else {
        return Promise.reject(data)
      }
    }).catch(handleError);
  },

  /**
   * 获取手签设置状态，参数为原始网页上的签名信息
   * @param signNo
   * @param sign
   * @param ts
   * @returns {Promise<T>}
   */
  hasSign ({signNo, sign, ts}) {
    let url = junziqianApi + ApiPort.userSign.hasSign;
    let jsonData = {signNo: signNo, sign: sign, ts: ts};

    return HttpAxios.post(url, jsonData).then(handleResponse).catch(handleError);
  }
}



// WEBPACK FOOTER //
// ./assets/js/http-serve/userSign.js